import { Card, Table } from "react-bootstrap";
import type { TriggerData } from "../lib/explainTypes";

interface Props {
  trigger: TriggerData;
}

// Reads `response.trigger`. Per architecture spec §3.3.
export default function TriggerPanel({ trigger }: Props) {
  return (
    <Card className="mb-3">
      <Card.Header>Trigger</Card.Header>
      <Card.Body>
        <div>
          <strong>Reason:</strong> {trigger.reason}
        </div>
        {trigger.reason_detail && (
          <div>
            <strong>Detail:</strong> {trigger.reason_detail}
          </div>
        )}
        {trigger.hint && (
          <div className="text-muted">
            <em>{trigger.hint}</em>
          </div>
        )}
        {trigger.allocation_drift.length > 0 ? (
          <Table size="sm" className="mt-3">
            <thead>
              <tr>
                <th>Allocation</th>
                <th className="text-end">Current</th>
                <th className="text-end">Target</th>
                <th className="text-end">Delta</th>
                <th>Breached</th>
              </tr>
            </thead>
            <tbody>
              {trigger.allocation_drift.map((row) => (
                <tr
                  key={row.name}
                  className={row.breached ? "table-warning" : undefined}
                >
                  <td>{row.name}</td>
                  <td className="text-end">{row.current}</td>
                  <td className="text-end">{row.target}</td>
                  <td className="text-end">{row.delta}</td>
                  <td>{row.breached ? "Yes" : "No"}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <div className="text-muted mt-3">No allocation drift recorded.</div>
        )}
      </Card.Body>
    </Card>
  );
}
